import THDStorageUtils, { COOKIE_STORAGE } from '@thd-olt-global/thd-storage-utils';

export const getCurrentCampaignOptions = ({ campaignOptions, segment }) => {
  if (!campaignOptions) {
    return {};
  }
  try {
    const parsedCampaignOptions = JSON.parse(campaignOptions);
    const currentCampaignOptionsKey = Object.keys(parsedCampaignOptions)
      .find((campaign) => parsedCampaignOptions[campaign].segments.includes(segment));
    if (!currentCampaignOptionsKey) {
      return {};
    }
    return {
      campaignId: currentCampaignOptionsKey,
      options: parsedCampaignOptions[currentCampaignOptionsKey],
    };
  } catch (error) {
    console.error('media-gallery: Error occurred while parsing campaign options', error);
    return {};
  }
};

// Helper function to trigger analytics
/*
  This is to trigger the analytics event for the decision engine
  when the page loads, we have a decision from the EdgeWorker, and the decision engine is enabled
  This only applies when we have a decision from the EdgeWorker,
  useVariationIds handles analytics for the super-sku clicks
*/
export const triggerAnalytics = ({ currentDECampaign, enableDeFeature }) => {
  const hasResponseFromEdgeWorker = !!currentDECampaign;
  if (!hasResponseFromEdgeWorker || !enableDeFeature) return;

  try {
    const cookie = THDStorageUtils.get(COOKIE_STORAGE, { key: 'Experiment' });
    if (!cookie || !window.LIFE_CYCLE_EVENT_BUS) return;

    const deExperiment = JSON.parse(cookie)?.decision_engine?.[currentDECampaign];
    if (typeof deExperiment === 'undefined') return;

    const { name: campaignName, test_group: testGroup, arm: decisionArm } = deExperiment;
    const timestamp = Date.now() - (Date.now() % 1000);
    // eslint-disable-next-line camelcase
    const post_de = [campaignName, testGroup, decisionArm, timestamp].join('|');

    window.LIFE_CYCLE_EVENT_BUS.trigger('decision-engine.api-call', { post_de, loading: false });
  } catch (error) {
    console.error('media-gallery: Error occurred while accessing cookie - Experiment', error);
  }
};